/* ============================================================
   ADMIN — Review module Partner (PLAN_PARTNER.md Fasa 3A, skrin 4–5)
   ============================================================
   Baca versi yang dihantar (3 mode) · banding dengan versi LIVE (peti besi
   module rasmi) · "Test this version" dengan produk admin (tidak dikira
   kuota Partner) · Request changes (nota WAJIB) · Approve.

   Approve module BAHARU = cipta module rasmi `p-…` berstatus Admin only.
   Approve KEMAS KINI = tukar master prompt module rasmi itu (versi lama
   diarkib ke sejarah Module Settings). Semua tulisan berlaku di server
   (functions/partnerStudio.js → adminLulus / adminMintaUbah).
   ============================================================ */
import { useEffect, useMemo, useState } from 'react';
import { ArrowLeft, Loader2, Play } from 'lucide-react';
import { Btn, Badge, Segmented } from '../design/ui';
import { panggilPartner, masaLalu, statusModul, MODE_KUNCI, MODE_LABEL, ENJIN_IKUT_FORMAT, labelFormat } from '../services/partnerStudioService';
import { useProdukLab, labelProduk, produkUntukServer, gambarProduk } from '../hooks/useProdukLab';
import { bezaBaris } from '../utils/bezaBaris';
import { useAvatarLab, avatarUntukServer } from '../hooks/useAvatarLab';
import { Kolum } from './PartnerTestLab';

// Senarai SAMA dengan modal "New module" admin (App.jsx ENGINE_PRESETS) — server menyemak semula.
const ENJIN = [
    { id: 'flow1', label: 'Flow 1-Scene (macam AI8SAAT)' },
    { id: 'flow2', label: 'Flow 2-Scene (macam AI16SAAT)' },
    { id: 'nscene', label: 'Flow N-Scene — AI auto, pilih babak' },
    { id: 'resipi', label: 'Flow Multi-Scene — 1 image, all scenes' },
    { id: 'goyang', label: 'GOYANG' },
    { id: 'manual', label: 'Manual — tiada AI (macam Smart)' },
];

const slug = (t) => `p-${String(t || '').toLowerCase().normalize('NFKD').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 36) || 'module'}`;

function TeksPrompt({ teks }) {
    return (
        <pre style={{ margin: 0, whiteSpace: 'pre-wrap', fontFamily: 'var(--s-mono)', fontSize: 12.5, lineHeight: 1.6, background: 'var(--s-ground)', border: '1px solid var(--s-line)', borderRadius: 8, padding: 12, maxHeight: 460, overflowY: 'auto' }}>
            {teks || <span className="s-dim">(empty)</span>}
        </pre>
    );
}

function Beza({ lama, baru }) {
    const baris = useMemo(() => bezaBaris(lama, baru), [lama, baru]);
    if (!baris) {
        return (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 10 }}>
                <div><p className="s-hint">Live</p><TeksPrompt teks={lama} /></div>
                <div><p className="s-hint">Sent</p><TeksPrompt teks={baru} /></div>
            </div>
        );
    }
    return (
        <pre style={{ margin: 0, whiteSpace: 'pre-wrap', fontFamily: 'var(--s-mono)', fontSize: 12.5, lineHeight: 1.6, border: '1px solid var(--s-line)', borderRadius: 8, padding: 12, maxHeight: 460, overflowY: 'auto', background: 'var(--s-ground)' }}>
            {baris.map((b, i) => (
                <div key={i} style={{
                    background: b.jenis === 'tambah' ? 'var(--s-ok-soft)' : b.jenis === 'buang' ? 'var(--s-stop-soft)' : undefined,
                    color: b.jenis === 'tambah' ? 'var(--s-ok)' : b.jenis === 'buang' ? 'var(--s-stop)' : undefined,
                    textDecoration: b.jenis === 'buang' ? 'line-through' : undefined,
                }}>{b.jenis === 'tambah' ? '+ ' : b.jenis === 'buang' ? '− ' : '  '}{b.teks || ' '}</div>
            ))}
        </pre>
    );
}

/* Juga dipakai sebagai PEMBACA module dari halaman butiran Partner (AdminPartnerButiran): `item.versi`
   kosong → versi lalai server (versi dihantar bila menunggu review, kalau tidak versi terkini). Butang
   Approve / Request changes HANYA muncul bila versi yang dibaca = versi yang sedang menunggu review. */
export default function AdminPartnerReview({ item, onKembali, onSelesai, labelKembali = 'Partners' }) {
    const [data, setData] = useState(null);
    const [versiDilihat, setVersiDilihat] = useState(item.versi ?? null);
    const [senaraiVersi, setSenaraiVersi] = useState([]);
    const [lihatDraf, setLihatDraf] = useState(false); // baca draf auto-save Partner (belum Save)
    const [ralatMuat, setRalatMuat] = useState('');
    const [mode, setMode] = useState(1);
    const [beza, setBeza] = useState(false);
    const [panel, setPanel] = useState(''); // '' | 'ubah' | 'lulus'
    const [nota, setNota] = useState('');
    const [borang, setBorang] = useState({ moduleId: slug(item.nama), nama: item.nama, engine: 'flow1', sceneCount: '3' });
    const [sibuk, setSibuk] = useState(false);
    const [ralat, setRalat] = useState('');
    const [uji, setUji] = useState({ sibuk: false, ralat: '', hasil: null });
    // Avatar — pilihan SAMA Workspace, ditapis ikut tab Mode yang sedang dibaca (Mode 1 = tiada; 2 = Default M/F; 3 = avatar simpanan admin).
    const av = useAvatarLab();
    const [avatarIdPilih, setAvatarIdPilih] = useState({});
    const [vision, setVision] = useState(true);
    const { produkList, produkId, setProdukId, produkSah } = useProdukLab('');

    useEffect(() => {
        let batal = false;
        (async () => {
            try {
                const [h, v] = await Promise.all([
                    panggilPartner('adminBaca', { uid: item.uid, modId: item.modId, versi: versiDilihat ?? undefined }),
                    panggilPartner('adminVersiSenarai', { uid: item.uid, modId: item.modId }),
                ]);
                if (!batal) { setData(h); setSenaraiVersi(v.versi || []); }
            } catch (e) { if (!batal) setRalatMuat(e?.message || 'Could not load this module.'); }
        })();
        return () => { batal = true; };
    }, [item.uid, item.modId, versiDilihat]);

    if (ralatMuat) return <div><Btn variant="quiet" size="sm" icon={<ArrowLeft size={14} />} onClick={onKembali}>{labelKembali}</Btn><p className="s-hint" style={{ color: 'var(--s-stop)' }}>{ralatMuat}</p></div>;
    if (!data) return <p className="s-hint"><Loader2 size={14} className="animate-spin" style={{ verticalAlign: -2 }} /> Loading…</p>;

    const kunci = MODE_KUNCI[mode];
    const pilihanMod = av.pilihan.filter((p) => p.mode === mode);
    const pilihAvatar = pilihanMod.find((p) => p.id === avatarIdPilih[mode]) || pilihanMod[0] || null;
    const live = data.live;
    // Bug #7 (27 Okt): module rasmi yang sudah DIPADAM → approve = cipta module baharu (borang penuh), bukan kemas kini.
    const kemasKini = !!live && live.wujud;
    const rasmiDipadam = !!live && !live.wujud;
    const st = statusModul(data.modul);
    // Tindakan semakan hanya pada versi yang SEDANG menunggu review (server menyemak semula).
    // Module tanpa versi → hanya draf yang boleh dibaca.
    const papDraf = !!data.draf && (lihatDraf || data.versi === 0);
    const promptPapar = papDraf ? data.draf.prompt : data.prompt;
    const bolehSemak = !papDraf && data.modul.semakan?.status === 'menunggu' && data.modul.semakan.versi === data.versi;

    const jalanUji = async () => {
        if (!produkSah?.hasData) { setUji({ sibuk: false, ralat: 'Choose a product marked READY first.', hasil: null }); return; }
        if (mode === 3 && !pilihAvatar) { setUji({ sibuk: false, ralat: 'Mode 3 needs a saved avatar. Add one in your account first.', hasil: null }); return; }
        if (vision && !gambarProduk(produkSah)) { setUji({ sibuk: false, ralat: 'This product has no photo. Turn Vision off or pick another product.', hasil: null }); return; }
        setUji({ sibuk: true, ralat: '', hasil: null });
        try {
            const h = await panggilPartner('adminUji', {
                uid: item.uid, modId: item.modId, versi: papDraf ? 'draf' : data.versi, mode,
                produk: produkUntukServer(produkSah, pilihAvatar?.gender || null, { vision }),
                vision,
                avatar: avatarUntukServer(pilihAvatar),
            }, { timeout: 170000 });
            setUji({ sibuk: false, ralat: '', hasil: h });
        } catch (e) { setUji({ sibuk: false, ralat: e?.message || 'Test failed.', hasil: null }); }
    };

    const mintaUbah = async () => {
        if (nota.trim().length < 3) { setRalat('Write a note so the partner knows what to change.'); return; }
        setSibuk(true); setRalat('');
        try {
            // Bug #5 (27 Okt): hantar versi yang DIBACA — server menolak kalau Partner sudah hantar versi lain.
            await panggilPartner('adminMintaUbah', { uid: item.uid, modId: item.modId, versi: data.versi, nota: nota.trim() });
            onSelesai(`Changes requested for ${item.nama}. The partner sees your note.`);
        } catch (e) { setRalat(e?.message || 'Could not send.'); setSibuk(false); }
    };

    // Format module Partner (29 Okt): hanya engine yang serasi dengan bentuk card yang diuji Partner.
    const formatModul = data.modul.format || null;
    const enjinSah = formatModul ? ENJIN.filter((x) => ENJIN_IKUT_FORMAT[formatModul].includes(x.id)) : ENJIN;
    const enjinPilih = enjinSah.some((x) => x.id === borang.engine) ? borang.engine : enjinSah[0]?.id;
    const lulus = async () => {
        if (!kemasKini) {
            if (!/^p-[a-z0-9][a-z0-9-]{1,37}$/.test(borang.moduleId)) { setRalat('Module ID must start with "p-" and use lowercase letters, numbers or "-".'); return; }
            if (borang.nama.trim().length < 2) { setRalat('Enter a display name.'); return; }
        }
        setSibuk(true); setRalat('');
        try {
            const h = await panggilPartner('adminLulus', {
                uid: item.uid, modId: item.modId, versi: data.versi,
                ...(kemasKini ? {} : { moduleId: borang.moduleId, nama: borang.nama.trim(), engine: enjinPilih, sceneCount: borang.sceneCount }),
            });
            onSelesai(h.baharu
                ? `Approved. Module ${h.moduleId} created (Admin only) — it's in your Workspace module list now.`
                : `Approved. Module ${h.moduleId} now uses version ${h.versi}. The old prompt is in its version history.`);
        } catch (e) { setRalat(e?.message || 'Could not approve.'); setSibuk(false); }
    };

    return (
        <div>
            <Btn variant="quiet" size="sm" icon={<ArrowLeft size={14} />} onClick={onKembali}>{labelKembali}</Btn>
            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap', margin: '8px 0 14px' }}>
                <div style={{ minWidth: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <h1 className="s-title" style={{ margin: 0 }}>{bolehSemak ? 'Review' : 'Module'} · {data.modul.nama} {papDraf ? '· unsaved draft' : `v${data.versi}`}</h1>
                        <Badge tone={st.tone}>{st.label}</Badge>
                        {bolehSemak && <Badge tone="brand">{kemasKini ? `Update to ${live.moduleId}` : 'New module'}</Badge>}
                    </div>
                    <p className="s-subtitle">
                        {data.partnerEmail} · {papDraf ? `draft auto-saved ${masaLalu(data.draf.dikemaskini)} — not a version yet` : `saved ${masaLalu(data.disimpanPada)}`}
                        {bolehSemak && data.modul.semakan?.nota ? ` · note: "${data.modul.semakan.nota}"` : ''}
                        {data.modul.modulRasmiId ? ` · approved module ${data.modul.modulRasmiId} (v${data.modul.versiLulus})` : ''}
                    </p>
                    {data.modul.semakan?.status === 'perlu_ubah' && <p className="s-hint" style={{ margin: '4px 0 0' }}>You asked for changes: "{data.modul.semakan.notaSesaat}"</p>}
                </div>
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
                    {(senaraiVersi.length > 1 || data.draf) && (
                        <select className="s-select" style={{ width: 'auto' }} value={papDraf ? 'draf' : data.versi} onChange={(e) => {
                            setPanel(''); setUji({ sibuk: false, ralat: '', hasil: null });
                            if (e.target.value === 'draf') { setLihatDraf(true); return; }
                            setLihatDraf(false); setVersiDilihat(Number(e.target.value));
                        }}>
                            {data.draf && <option value="draf">Unsaved draft · {masaLalu(data.draf.dikemaskini)}</option>}
                            {senaraiVersi.map((v) => (
                                <option key={v.versi} value={v.versi}>
                                    Version {v.versi}{v.versi === data.modul.versiSemasa ? ' (latest)' : ''}{v.versi === data.modul.versiLulus ? ' · approved' : ''}{data.modul.semakan?.status === 'menunggu' && v.versi === data.modul.semakan.versi ? ' · in review' : ''}
                                </option>
                            ))}
                        </select>
                    )}
                    {bolehSemak && <Btn size="sm" variant="ghost" onClick={() => { setPanel(panel === 'ubah' ? '' : 'ubah'); setRalat(''); }}>Request changes</Btn>}
                    {bolehSemak && <Btn size="sm" onClick={() => { setPanel(panel === 'lulus' ? '' : 'lulus'); setRalat(''); }}>{kemasKini ? 'Approve update…' : 'Approve…'}</Btn>}
                </div>
            </div>

            {bolehSemak && panel === 'ubah' && (
                <div className="s-card" style={{ marginBottom: 14 }}>
                    <div className="s-sect">
                        <label>
                            <span className="s-lbl">What should the partner change?</span>
                            <textarea className="s-input" value={nota} maxLength={1000} autoFocus onChange={(e) => { setNota(e.target.value); setRalat(''); }}
                                placeholder="Hook terlalu panjang, pendekkan bawah 8 patah perkataan"
                                style={{ height: 'auto', minHeight: 80, padding: 10, resize: 'vertical' }} />
                        </label>
                        {ralat && <p className="s-hint" style={{ margin: 0, color: 'var(--s-stop)' }}>{ralat}</p>}
                        <div style={{ display: 'flex', gap: 8 }}>
                            <Btn size="sm" onClick={mintaUbah} disabled={sibuk}>{sibuk ? 'Sending…' : 'Send to partner'}</Btn>
                            <Btn size="sm" variant="ghost" onClick={() => setPanel('')} disabled={sibuk}>Cancel</Btn>
                        </div>
                    </div>
                </div>
            )}

            {bolehSemak && panel === 'lulus' && (
                <div className="s-card" style={{ marginBottom: 14 }}>
                    <div className="s-sect">
                        {kemasKini ? (
                            <p style={{ margin: 0 }}>
                                Module <strong>{live.moduleId}</strong> will use version {data.versi} for all 3 modes.
                                {' Its current prompt is kept in the module version history (Module Settings).'}
                                {' '}It stays Admin only.
                            </p>
                        ) : (
                            <>
                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(190px, 1fr))', gap: 12 }}>
                                    <label>
                                        <span className="s-lbl">Module ID</span>
                                        <input className="s-input" value={borang.moduleId} maxLength={40}
                                            onChange={(e) => setBorang({ ...borang, moduleId: e.target.value.toLowerCase().trim() })} />
                                    </label>
                                    <label>
                                        <span className="s-lbl">Display name</span>
                                        <input className="s-input" value={borang.nama} maxLength={60} onChange={(e) => setBorang({ ...borang, nama: e.target.value })} />
                                    </label>
                                    <label>
                                        <span className="s-lbl">Engine automation</span>
                                        <select className="s-select" value={enjinPilih} onChange={(e) => setBorang({ ...borang, engine: e.target.value })}>
                                            {enjinSah.map((x) => <option key={x.id} value={x.id}>{x.label}</option>)}
                                        </select>
                                        {formatModul && <span className="s-hint" style={{ display: 'block', margin: '4px 0 0' }}>Partner built this as {labelFormat(formatModul)} — only matching engines.</span>}
                                    </label>
                                    {!formatModul && (enjinPilih === 'nscene' || enjinPilih === 'resipi') && (
                                        <label>
                                            <span className="s-lbl">Scenes</span>
                                            <select className="s-select" value={borang.sceneCount} onChange={(e) => setBorang({ ...borang, sceneCount: e.target.value })}>
                                                {(enjinPilih === 'nscene' ? [2, 3, 4, 5, 6] : [1, 2, 3, 4, 5]).map((n) => <option key={n} value={String(n)}>{n}</option>)}
                                            </select>
                                        </label>
                                    )}
                                    <div>
                                        <span className="s-lbl">Access</span>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, height: 36 }}><Badge>Admin only</Badge><span className="s-dim" style={{ fontSize: 12 }}>customers come in 3B</span></div>
                                    </div>
                                </div>
                                {rasmiDipadam && (
                                    <p className="s-hint" style={{ margin: 0, color: 'var(--s-warn)' }}>
                                        The module approved before ({live.moduleId}) was deleted, so this creates a new module.
                                    </p>
                                )}
                                <p className="s-hint" style={{ margin: 0 }}>
                                    Copies version {data.versi} (all 3 modes) into the new module's vault. Later partner edits do NOT change this module until you approve an update.
                                    The engine can't be changed after the module is created.
                                </p>
                            </>
                        )}
                        {ralat && <p className="s-hint" style={{ margin: 0, color: 'var(--s-stop)' }}>{ralat}</p>}
                        <div style={{ display: 'flex', gap: 8 }}>
                            <Btn size="sm" onClick={lulus} disabled={sibuk}>{sibuk ? 'Approving…' : kemasKini ? `Approve version ${data.versi}` : 'Approve and create module'}</Btn>
                            <Btn size="sm" variant="ghost" onClick={() => setPanel('')} disabled={sibuk}>Cancel</Btn>
                        </div>
                    </div>
                </div>
            )}

            <div className="s-card" style={{ marginBottom: 14 }}>
                <div className="s-sect">
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, flexWrap: 'wrap' }}>
                        <div style={{ overflowX: 'auto' }}>
                            <Segmented value={mode} onChange={setMode} options={[1, 2, 3].map((n) => ({
                                value: n, label: `${MODE_LABEL[n]}${(promptPapar[MODE_KUNCI[n]] || '').trim() ? '' : ' · empty'}`,
                            }))} />
                        </div>
                        {kemasKini && (
                            <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13 }}>
                                <input type="checkbox" checked={beza} onChange={(e) => setBeza(e.target.checked)} />
                                Show changes vs live{live.versi ? ` v${live.versi}` : ''}
                            </label>
                        )}
                    </div>
                    {beza && kemasKini ? <Beza lama={live.prompt[kunci]} baru={promptPapar[kunci]} /> : <TeksPrompt teks={promptPapar[kunci]} />}
                </div>
            </div>

            <div className="s-card">
                <div className="s-sect">
                    <span className="s-lbl" style={{ margin: 0 }}>{papDraf ? 'Test this draft' : 'Test this version'} · {MODE_LABEL[mode]}</span>
                    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                        <select className="s-select" style={{ flex: 1, minWidth: 200 }} value={produkId} disabled={!produkList.dimuat} onChange={(e) => setProdukId(e.target.value)}>
                            <option value="">{produkList.dimuat ? 'Choose a product' : 'Loading products…'}</option>
                            {produkList.sendiri.length > 0 && <optgroup label="Your My Products">{produkList.sendiri.map((it) => <option key={it.id} value={it.id}>{labelProduk(it)}</option>)}</optgroup>}
                            {produkList.sampel.length > 0 && <optgroup label="System products">{produkList.sampel.map((it) => <option key={it.id} value={it.id}>{labelProduk(it)}</option>)}</optgroup>}
                        </select>
                        {mode !== 1 && (
                            <select className="s-select" style={{ width: 220 }} value={pilihAvatar?.id || ''} onChange={(e) => setAvatarIdPilih({ ...avatarIdPilih, [mode]: e.target.value })}>
                                {pilihanMod.length === 0 && <option value="">No saved avatars</option>}
                                {pilihanMod.map((p) => <option key={p.id} value={p.id}>{p.nama}</option>)}
                            </select>
                        )}
                        <Btn size="sm" icon={<Play size={14} />} onClick={jalanUji} disabled={uji.sibuk || !(promptPapar[kunci] || '').trim()}>{papDraf ? 'Test this draft' : 'Test this version'}</Btn>
                    </div>
                    <p className="s-hint" style={{ margin: 0 }}>
                        Same AI call as the partner's lab (gpt-5-mini · low). Not counted in the partner's 100 daily tests.
                        {' '}Avatar choices are the same as Workspace (your saved avatars for Mode 3).
                    </p>
<label style={{ display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 13 }}>
                        <input type="checkbox" checked={vision} onChange={(e) => { setVision(e.target.checked); }} style={{ marginTop: 3 }} />
                        <span><strong>Vision</strong> — send the product photo to the AI with the prompt (same as the SESAAT admin lab). The AI follows the photo for what the product looks like.</span>
                    </label>
                    {vision && produkSah && !gambarProduk(produkSah) && <p className="s-hint" style={{ margin: 0, color: 'var(--s-warn)' }}>This product has no photo. Turn Vision off or pick another product.</p>}
                    {produkList.ralat && <p className="s-hint" style={{ margin: 0, color: 'var(--s-stop)' }}>{produkList.ralat}</p>}
                    {(uji.sibuk || uji.ralat || uji.hasil) && <Kolum tunjukKos format={data.modul.format || null} tajuk={`${papDraf ? 'Unsaved draft' : `Version ${data.versi}`} · ${MODE_LABEL[mode]}`} {...uji} />}
                </div>
            </div>
        </div>
    );
}
